import { Row, Col, RadioFieldGroup } from '@gv/triage-components';

import { priorities } from './config';
import { ConcernProps } from './types';
import { dynamicPriorities } from './dynamic_config';

export const Concern = ({ isCSR, isDynamic = false }: ConcernProps) => {
  if (isCSR && !isDynamic) {
    return null;
  }

  return (
    <Row>
      <Col
        style={{
          marginBottom: '0px',
        }}
      >
        <RadioFieldGroup
          label="Case status"
          name="priority_of_concern"
          items={isDynamic ? dynamicPriorities : priorities}
        />
      </Col>
    </Row>
  );
};

export type { ConcernProps };
